export const MIN_IDENTIFIER_LENGTH = 4;

/** Shared between Single Screening and Monitoring entry creation — same field, same rule. */
export function validateIdentifier(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;
  if (trimmed.length < MIN_IDENTIFIER_LENGTH) {
    return `Identifier must be at least ${MIN_IDENTIFIER_LENGTH} characters`;
  }
  return null;
}
